import { AnyAction, createReducer } from '@reduxjs/toolkit';
import {
	acceptTermsAndConditions,
	acceptTermsAndConditionsRejected,
	acceptTermsAndConditionsResolved,
	setUserContext,
} from '../actions/userContext.actions';

import { InnovyzeRole } from '../utils/InnovyzeRole';
import { UserContext } from '../types/userContext';
import { clearCache } from '../actions/app.actions';
import { injectProject } from '../actions/authenticationContext.actions';
import { userTeamAccessVerifyResolved } from '../actions/userTeamAccess.actions';

export const initialState: UserContext = {
	defaultSite: '',
	defaultSiteProjectId: '',
	defaultTeamId: '',
	innovyzeRole: InnovyzeRole.READ_ONLY,
	id: '',
	email: '',
	name: '',
	teamId: '',
	entitlements: [],
	termsAndConditions: {
		status: 'idle',
	},
	productAccessLevels: [],
	loading: false,
};

interface UserContextReducer {
	[x: string]: (
		state: UserContext,
		action: AnyAction,
	) => UserContext | undefined;
}

const reducer: UserContextReducer = {
	[setUserContext.toString()]: (state, action) => ({
		...state,
		...action.payload,
		loading: false,
	}),
	[acceptTermsAndConditions.toString()]: state => {
		return { ...state, termsAndConditions: { status: 'loading' } };
	},
	[acceptTermsAndConditionsResolved.toString()]: (state, action) => {
		return {
			...state,
			termsAndConditions: { ...action.payload, status: 'resolved' },
		};
	},
	[acceptTermsAndConditionsRejected.toString()]: state => {
		return { ...state, termsAndConditions: { status: 'rejected' } };
	},
	[injectProject.toString()]: (state, { payload: { organizationId } }) => {
		return { ...state, defaultSite: organizationId, loading: true };
	},
	[clearCache.toString()]: () => ({ ...initialState }),
	[userTeamAccessVerifyResolved.toString()]: (state, action) => ({
		...state,
		loading: false,
	}),
};

export default createReducer(initialState, reducer);
